import React from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    List,
    ListItem,
    ListItemText,
} from '@mui/material';

const ImportSuccessDialog = ({ open, onClose, successData }) => {
    if (!successData) return null;

    const { message, errors = [] } = successData;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Forecast import result</DialogTitle>
            <DialogContent>
                <Typography variant="body1" paragraph>
                    {message}
                </Typography>
                {errors.length > 0 && (
                    <>
                        <Typography variant="subtitle2" sx={{ mt: 1 }}>
                            Skipped rows:
                        </Typography>
                        <List dense sx={{ maxHeight: 300, overflow: 'auto' }}>
                            {errors.map((error, index) => (
                                <ListItem key={index}>
                                    <ListItemText primary={error} primaryTypographyProps={{ variant: 'body2' }} />
                                </ListItem>
                            ))}
                        </List>
                    </>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

ImportSuccessDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    successData: PropTypes.shape({
        message: PropTypes.string,
        updatedCount: PropTypes.number,
        skippedCount: PropTypes.number,
        errors: PropTypes.arrayOf(PropTypes.string),
    }),
};

export default ImportSuccessDialog;
